import { AppLink } from "./router";

export function LegalFooter() {
  return <footer className="legal-footer"><span>Precise Plate by Ritual App Labs Inc.</span><nav><AppLink href="/why-precise-plate">Why Precise Plate</AppLink><AppLink href="/privacy">Privacy</AppLink><AppLink href="/terms">Terms</AppLink><AppLink href="/medical-disclaimer">Medical disclaimer</AppLink><AppLink href="/support">Support</AppLink><AppLink href="/delete-account">Delete account</AppLink></nav></footer>;
}
